/** ============================================================= *
 *  ---------------------- IMPORT - START ----------------------- *
 *  ============================================================= */
import 'what-input'
import jQuery from 'jquery'
import Foundation from 'foundation-sites'
import intlTelInput from 'intl-tel-input'
import Swiper, { Navigation, Pagination, Virtual, Grid, Autoplay } from 'swiper'
import { setHrefs } from './functions/data-hrefs'
import { initEqualizeContent } from './functions/equalizer'
import { initTelephoneInput } from './functions/intl-tel-input'
import { initDatepickerInput } from './functions/datepicker'
import { enableNegativeMargins } from './functions/negative-margins'
import { mapStyles } from './functions/map-styles'
// import { enableCallrailTracking } from './functions/callrail'
/** ============================================================= *
 *  ----------------------- IMPORT - END ------------------------ *
 *  ============================================================= */



/** ============================================================= *
 *  ------------ GLOBAL VARIABLES DECLARATION - START ----------- *
 *  ============================================================= */
const THEME_FOLDER = "../wp-content/themes/c3hie_v1"
const PHONE_FIELD = ".codesm-phone-field"
const DATEPICKER_FIELD = ".codesm-datepicker-field"
const DATEPICKER_FORMAT = "mm/dd/yyyy"
const EQUALIZE_CONTENT = ".codesm-equalize-content"

Foundation.addToJquery(jQuery)
Swiper.use([Navigation, Pagination, Virtual, Grid, Autoplay])
window.intlTelInput = intlTelInput
window.setHrefs = setHrefs
window.initEqualizeContent = initEqualizeContent
window.initTelephoneInput = initTelephoneInput
window.initDatepickerInput = initDatepickerInput
window.enableNegativeMargins = enableNegativeMargins
window.mapStyles = mapStyles
// window.enableCallrailTracking = enableCallrailTracking
/** ============================================================= *
 *  ------------- GLOBAL VARIABLES DECLARATION - END ------------ *
 *  ============================================================= */



jQuery(document).ready(function(){
	jQuery(document).foundation();
	triggerThemeFunctions();

	

	// TESTIMONIALS SWIPER
	var testimonialSwiper = new Swiper('#testimonials .swiper-container',{
		slidesPerView: 1,
		spaceBetween: 0,
		autoHeight: true,
		watchOverflow: true,
		pagination: {
			clickable: true,
			type: 'bullets',
			el: '#testimonials .swiper-pagination',
		},
		breakpoints: {
			1440: {
				slidesPerView: 1,
				spaceBetween: 0,
			},
			1200: {
				slidesPerView: 1,
				spaceBetween: 0,
			},
			1024: {
				slidesPerView: 1,
				spaceBetween: 0,
			},
			640: {
				slidesPerView: 1,
				spaceBetween: 0,
			}
		},
	});

		// ACO QUALITY ORGANIZATIONS PROVIDERS SWIPER
		var acoQualityOrganizationsProvidersSwiper = new Swiper('#aco-quality-organizations-providers-swiper-logos .swiper-container',{
			spaceBetween: 0,
			loop: true,
			slidesPerView: 1,
			// slidesPerColumn: 2,
			//slidesPerColumnFill: "row",
			// slidesPerGroup: 2,
			// slidesPerView: 4,
			// spaceBetween: 30,
			// grid: {
			// 	rows: 2,
			// },
			autoplay: {
				delay: 2000,
				disableOnInteraction: false,
			},
			pagination: {
				clickable: true,
				type: 'bullets',
				el: '#aco-quality-organizations-providers-swiper-logos .swiper-pagination',
			},
			breakpoints: {
				640: {
					slidesPerView: 2,
				},
				1024: {
					slidesPerView: 3,
				},
				1200: {
					slidesPerView: 3,
				},
				1440: {
					slidesPerView: 4,
				},
			},
		});

	// LOGOS SWIPER CAROUSEL
	const buildSwiperSlider = sliderElm => {
		const swiperContainer = sliderElm.children[0];
		const desktopElements = sliderElm.getAttribute('data-show-elements') ?? 'auto';
		return new Swiper(swiperContainer, {
			loop: true,
			slidesPerView: 1,
			spaceBetween: 0,
			autoplay: {
				delay: 2000,
				disableOnInteraction: false,
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			breakpoints: {
				640: {
					slidesPerView: 2,
					spaceBetween: 20,
				},
				1024: {
					slidesPerView: 3,
					spaceBetween: 30,
				},
				1200: {
					slidesPerView: 4,
					spaceBetween: 45,
				},
				1440: {
					slidesPerView: desktopElements,
					spaceBetween: 60,
				},
			},
		});
	}

	const allSliders = document.querySelectorAll('.swiper-logos');
	allSliders.forEach(slider => buildSwiperSlider(slider));


	(function($) {
		/*
		*  new_map
		*
		*  This function will render a Google Map onto the selected jQuery element
		*
		*  @type	function
		*  @date	8/11/2013
		*  @since	4.3.0
		*
		*  @param	$el (jQuery element)
		*  @return	n/a
		*/

		function new_map( $el ) {

			// var
			var $markers = $el.find('.marker');
			
			
			// vars
			var args = {
				zoom		: 16,
				center		: new google.maps.LatLng(26.190351, -97.676619),
				mapTypeId	: google.maps.MapTypeId.ROADMAP
			};
			
			
			// create map	        	
			var map = new google.maps.Map( $el[0], args);
			
			
			// add a markers reference
			map.markers = [];
			
			
			// add markers
			$markers.each(function(){
				
				add_marker( $(this), map );
				
			});
			
			
			// center map
			center_map( map );
			
			
			// return
			return map;
			
		}

		/*
		*  add_marker
		*
		*  This function will add a marker to the selected Google Map
		*
		*  @type	function
		*  @date	8/11/2013
		*  @since	4.3.0
		*
		*  @param	$marker (jQuery element)
		*  @param	map (Google Map object)
		*  @return	n/a
		*/

		function add_marker( $marker, map ) {

			// var
			var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

			var marker_url = `/wp-content/themes/c3hie_v1/assets/images/location-markers/${$marker.attr('data-marker')}.svg`;
			var marker_icon = {
				url			: marker_url, // url
				// size		: new google.maps.Size(120, 120), // size
				scaledSize	: new google.maps.Size(30, 30), // scaled size
				origin		: new google.maps.Point(0, 0), // origin
				anchor		: new google.maps.Point(15, 30), // anchor
				optimized	: true,
				scale		: 0.25,
			};
			
			// var marker_icon = new google.maps.MarkerImage(
			// 	marker_url,
			// 	null, 
			// 	null, 
			// 	null, 
			// 	new google.maps.Size(30, 30)
			// );

			var marker_options = 
			{
				position	: latlng,
				map			: map,
				icon		: marker_icon
			};

			// create marker
			var marker = new google.maps.Marker(marker_options);
			if ($marker.attr('data-zindex')){
				marker.setZIndex(9999);
			}

			// add to array
			map.markers.push( marker );

			// if marker contains HTML, add it to an infoWindow
			if( $marker.html() )
			{
				// create info window
				var infowindow = new google.maps.InfoWindow({
					content		: $marker.html()
				});

				// show info window when marker is clicked
				google.maps.event.addListener(marker, 'click', function() {

					map.setCenter(marker.getPosition());
					infowindow.open( map, marker );

				});
			}

		}

		/*
		*  center_map
		*
		*  This function will center the map, showing all markers attached to this map
		*
		*  @type	function
		*  @date	8/11/2013
		*  @since	4.3.0
		*
		*  @param	map (Google Map object)
		*  @return	n/a
		*/

		function center_map( map ) {
			// vars
			var bounds = new google.maps.LatLngBounds();

			// loop through all markers and create bounds
			$.each( map.markers, function( i, marker ){

				var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

				bounds.extend( latlng );

			});

			// only 1 marker?
			if( map.markers.length == 1 )
			{
				// set center of map
				map.setCenter( bounds.getCenter() );
				map.setZoom( 16 );
			}
			else
			{
				// fit to bounds
				map.fitBounds( bounds );
			}

		}

		/*
		*  document ready
		*
		*  This function will render each map when the document is ready (page has loaded)
		*
		*  @type	function
		*  @date	8/11/2013
		*  @since	5.0.0
		*
		*  @param	n/a
		*  @return	n/a
		*/
		// global var
		var map = null;

		$(document).ready(function(){

			$('.acf-map').each(function(){

				// create map
				window.map = new_map( $(this) );
			});

			// providerDataTable = $('#provider-datatable').DataTable({
			// 	"dom": 'Bfrtip',
			// 	"columnDefs": [
			// 		{
			// 			"targets": [ 2 ],
			// 			"visible": false
			// 		},
			// 		{
			// 			"targets": [ 4 ],
			// 			"visible": false
			// 		}
			// 	],
			// 	"pagingType": "numbers",
			// 	"buttons": [
			// 		'csv', 'excel', 'pdf', 'print'
			// 	]
			// });

			// $('#customSearchBox').keyup(function(){
			// 	providerDataTable.search($(this).val()).draw();
			// });
			
		});
	})(jQuery);

});



/** ======= DO NOT EDIT BELOW THIS POINT UNLESS NECESSARY ======= *
 *  ----------------- THEME FUNCTIONS - START ------------------- *
 *  ======= DO NOT EDIT BELOW THIS POINT UNLESS NECESSARY ======= */
function triggerThemeFunctions()
{
	// REMOVE EMPTY P TAGS CREATED BY WP INSIDE OF ACCORDION AND ORBIT
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// ADD FLEX VIDEO TO YOUTUBE AND VIMEO EMBEDS
	jQuery(':not(.responsive-embed):not(.flex-video)>iframe[src*="youtube.com"], :not(.responsive-embed):not(.flex-video)>iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
			jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
			jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	// ENABLE PSEUDO ELEMENTS FOR FONT AWESOME
	window.FontAwesomeConfig = {
		searchPseudoElements: true
	};

	// DISABLE FIRST OPTION
	jQuery('select.disable-first-option').each(function(){
		jQuery(this).find('option').first().attr('disabled', 'disabled');
	});

	// HANDLE DATA-HREF
	window.setHrefs();

	// TRIGGER EQUALIZER
	window.initEqualizeContent(EQUALIZE_CONTENT);

	// INTL-TEL-INPUT
	window.initTelephoneInput(PHONE_FIELD, THEME_FOLDER);

	// ENABLE NEGATIVE MARGINS
	window.enableNegativeMargins();

	// FOUNDATION DATEPICKER
	window.initDatepickerInput(DATEPICKER_FIELD, DATEPICKER_FORMAT);

	// // ENABLE CALLRAIL TRACKING
	// window.enableCallrailTracking();
}
/** ======= DO NOT EDIT ABOVE THIS POINT UNLESS NECESSARY ======= *
 *  ------------------ THEME FUNCTIONS - END -------------------- *
 *  ======= DO NOT EDIT ABOVE THIS POINT UNLESS NECESSARY ======= */